import { fetchJson2 } from 'helpers/api';

const fetchTableColumnsOverrides = (tableName, roleCode, cancellationToken) => {
  const searchParams = new URLSearchParams({ roleCode });
  const tableNameRouteParam = encodeURIComponent(tableName);
  return fetchJson2(`/api/table-overrides/${tableNameRouteParam}?${searchParams}`, cancellationToken);
};

export { fetchTableColumnsOverrides };
